import { render } from "./ResultItemCardMain.vue?vue&type=template&id=16463814&scoped=true"
import script from "./ResultItemCardMain.vue?vue&type=script&lang=js"
export * from "./ResultItemCardMain.vue?vue&type=script&lang=js"

import "./ResultItemCardMain.vue?vue&type=style&index=0&id=16463814&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16463814"]])

export default __exports__